import { useCallback, useMemo, useState } from 'react';
import useAvailableOffersStateBase from '@fingo/lib/features/factoring/hooks/useAvailableOffersStateBase';
import useOperationAvailabilityAction from '@fingo/lib/hooks/useOperationAvailabilityAction';
import OPTIONS from '../constants/available-offers-options';

const useAvailableOffersState = () => {
  const baseState = useAvailableOffersStateBase({
    getRowConstraintValue: OPTIONS.getRowConstraintValue,
  });

  const {
    setShowConfirmationSummary,
    setShowCessionStep,
  } = baseState;

  const {
    isBlocked,
    unavailabilityCode,
    blockOperationDialogProps,
    handleActionClick,
    handleShowConfirmationSummary,
  } = useOperationAvailabilityAction(setShowConfirmationSummary);

  const [cessionStepperNavigation, setCessionStepperNavigation] = useState(null);

  const handleRegisterCessionNavigation = useCallback((currentCessionStepperActions) => {
    setCessionStepperNavigation(currentCessionStepperActions);
  }, []);

  const handleBackInCessionSubStep = useCallback(() => {
    cessionStepperNavigation?.prevStep?.();
  }, [cessionStepperNavigation]);

  const handleBackToBeginAdvancePayment = useCallback(() => {
    setShowConfirmationSummary(false);
  }, [setShowConfirmationSummary]);

  const handleBackToDateSelection = useCallback(() => {
    setShowCessionStep(false);
  }, [setShowCessionStep]);

  const stepsCallbacks = useMemo(() => ({
    handleBackToBeginAdvancePayment,
    handleBackToDateSelection,
    handleBackInCessionSubStep,
  }), [
    handleBackToBeginAdvancePayment,
    handleBackToDateSelection,
    handleBackInCessionSubStep,
  ]);

  return {
    ...baseState,
    isBlocked,
    unavailabilityCode,
    blockOperationDialogProps,
    handleActionClick,
    handleShowConfirmationSummary,
    handleRegisterCessionNavigation,
    cessionStepperNavigation,
    stepsCallbacks,
  };
};

export default useAvailableOffersState;
